export default {
  tableDataCampaigns: state => {
    return state.campaignList
  },
  tableDataEsacVoucherTypes: state => {
    return state.esacVoucherTypeList
  },
  tableDataEsacVoucherSubTypes: state => {
    return state.esacVoucherSubTypeList
  },
  tableDataEsacPromotions: state => {
    return state.esacPromotionList
  },
  tableDataEsacVouchers: state => {
    return state.esacVoucherList
  },
  tableDataEsacRedemptions: state => {
    return state.esacRedemptionList
  },
}
